
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reservation_terms",
      function () {
        return require("private-next-pages/reservation_terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reservation_terms"])
      });
    }
  